import { useContext, useMemo } from "react";
import { ProcessContext } from "../../../../../../../contexts/ProcessContext";

export const usePaymentPlan = (paymentPlanLineId) => {
  const {
    state: { paymentPlan },
    dispatch,
  } = useContext(ProcessContext);

  const getPaymentPlanByPaymentPlanLineId = () => {
    dispatch({
      type: "REQUEST_GET_PAYMENT_PLAN_BY_PAYMENT_LINE_ID",
      payload: paymentPlanLineId,
    });
  };

  const patchUpdatePaymentPlanLineStatus = (paymentPlanLineStatus) => {
    dispatch({
      type: "REQUEST_PATCH_UPDATE_PAYMENT_PLAN_LINE_STATUS",
      payload: {
        paymentPlanLineId,
        paymentPlanLineStatus,
      },
    });
  };

  const currentPaymentPlanLine = useMemo(() => {
    if (!paymentPlan) return;
    return paymentPlan.lines.find(
      (paymentPlanLine) => paymentPlanLine.id === paymentPlanLineId
    );
  }, [paymentPlan]);

  return {
    paymentPlan,
    currentPaymentPlanLine,
    getPaymentPlanByPaymentPlanLineId,
    patchUpdatePaymentPlanLineStatus,
  };
};
